import "./PPZone.module.css";
import NewsHero from "./sections/NewsHero";
import Capabilities from "./sections/Capabilities";
import ZonaPPCategoryGrid from "./sections/ZonaPPCategoryGrid";
import Footer from "./sections/Footer";
import GlossyBottomNavigation from "./sections/GlossyBottomNavigation";
export default function PPZonePage() {
  return <div>
      <NewsHero />
      <Capabilities />
      <ZonaPPCategoryGrid />
      <GlossyBottomNavigation />
      <Footer />
    </div>;
}